import {useMutation} from '@tanstack/react-query'
import {httpGetMeasureRawHtml} from '@/features/measure-details/services/measureDetails.http.ts'

export const useGetMeasureRawHtml = () => {
    return useMutation({
        mutationFn: (id: string) => {
            return httpGetMeasureRawHtml(id)
        }
    })
}
